/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type StripeStatus = "MORE_REQUIRED" | "NOT_STARTED" | "ONBOARDED" | "%future added value";
export type MerchantBilling_QueryVariables = {
    accountID?: string | null;
    financesBefore: string;
    financesAfter: string;
};
export type MerchantBilling_QueryResponse = {
    readonly account: {
        readonly merchant: {
            readonly payments: {
                readonly stripeSetupStatus: StripeStatus;
                readonly stripePayoutsEnabled: boolean;
            } | null;
            readonly stripeBalance: {
                readonly available: {
                    readonly value: number;
                    readonly currency: string;
                };
                readonly pending: {
                    readonly value: number;
                    readonly currency: string;
                };
            };
            readonly " $fragmentRefs": FragmentRefs<"MerchantFinances_merchant">;
        } | null;
    };
};
export type MerchantBilling_Query = {
    readonly response: MerchantBilling_QueryResponse;
    readonly variables: MerchantBilling_QueryVariables;
};



/*
query MerchantBilling_Query(
  $accountID: ID
  $financesBefore: Time!
  $financesAfter: Time!
) {
  account(input: {accountID: $accountID}) {
    merchant {
      payments {
        stripeSetupStatus
        stripePayoutsEnabled
      }
      stripeBalance {
        available {
          value
          currency
        }
        pending {
          value
          currency
        }
      }
      ...MerchantFinances_merchant
      id
    }
    id
  }
}

fragment MerchantFinances_merchant on Merchant {
  finances(before: $financesBefore, after: $financesAfter) {
    totalSales
    totalFees
    totalTaxes
  }
  id
}
*/

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "accountID"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "financesAfter"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "financesBefore"
},
v3 = [
  {
    "fields": [
      {
        "kind": "Variable",
        "name": "accountID",
        "variableName": "accountID"
      }
    ],
    "kind": "ObjectValue",
    "name": "input"
  }
],
v4 = {
  "alias": null,
  "args": null,
  "concreteType": "Payments",
  "kind": "LinkedField",
  "name": "payments",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "stripeSetupStatus",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "stripePayoutsEnabled",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v5 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "value",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "currency",
    "storageKey": null
  }
],
v6 = {
  "alias": null,
  "args": null,
  "concreteType": "Balance",
  "kind": "LinkedField",
  "name": "stripeBalance",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "Amount",
      "kind": "LinkedField",
      "name": "available",
      "plural": false,
      "selections": (v5/*: any*/),
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Amount",
      "kind": "LinkedField",
      "name": "pending",
      "plural": false,
      "selections": (v5/*: any*/),
      "storageKey": null
    }
  ],
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "MerchantBilling_Query",
    "selections": [
      {
        "alias": null,
        "args": (v3/*: any*/),
        "concreteType": "Account",
        "kind": "LinkedField",
        "name": "account",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Merchant",
            "kind": "LinkedField",
            "name": "merchant",
            "plural": false,
            "selections": [
              (v4/*: any*/),
              (v6/*: any*/),
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "MerchantFinances_merchant"
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v2/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Operation",
    "name": "MerchantBilling_Query",
    "selections": [
      {
        "alias": null,
        "args": (v3/*: any*/),
        "concreteType": "Account",
        "kind": "LinkedField",
        "name": "account",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Merchant",
            "kind": "LinkedField",
            "name": "merchant",
            "plural": false,
            "selections": [
              (v4/*: any*/),
              (v6/*: any*/),
              {
                "alias": null,
                "args": [
                  {
                    "kind": "Variable",
                    "name": "after",
                    "variableName": "financesAfter"
                  },
                  {
                    "kind": "Variable",
                    "name": "before",
                    "variableName": "financesBefore"
                  }
                ],
                "concreteType": "MerchantFinances",
                "kind": "LinkedField",
                "name": "finances",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "totalSales",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "totalFees",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "totalTaxes",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              (v7/*: any*/)
            ],
            "storageKey": null
          },
          (v7/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "5605f05ccfe69fde155df8dfe5d73f4f",
    "id": null,
    "metadata": {},
    "name": "MerchantBilling_Query",
    "operationKind": "query",
    "text": "query MerchantBilling_Query(\n  $accountID: ID\n  $financesBefore: Time!\n  $financesAfter: Time!\n) {\n  account(input: {accountID: $accountID}) {\n    merchant {\n      payments {\n        stripeSetupStatus\n        stripePayoutsEnabled\n      }\n      stripeBalance {\n        available {\n          value\n          currency\n        }\n        pending {\n          value\n          currency\n        }\n      }\n      ...MerchantFinances_merchant\n      id\n    }\n    id\n  }\n}\n\nfragment MerchantFinances_merchant on Merchant {\n  finances(before: $financesBefore, after: $financesAfter) {\n    totalSales\n    totalFees\n    totalTaxes\n  }\n  id\n}\n"
  }
};
})();
(node as any).hash = '3126a32df19f36a50b78d5bbf28de8aa';
export default node;
